import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import SSRAwareQuery from '../components/SSRAwareQuery';
import gql from 'graphql-tag';

export const query = gql`
  query maxymiserSettings {
    application(name: HOTELONLYBOOKING) {
      ... on HotelOnlyBooking {
        configurations {
          maxymiserScriptLocation
          maxymiserEnabled
        }
      }
    }
  }
`;

const MaxymiserProvider = ({ children }) => {
  return (
    <SSRAwareQuery query={query} ssr={true}>
      {({ data, error, loading }) => {
        if (loading) {
          return null;
        }
        if (error) {
          throw error;
        }
        const {
          maxymiserScriptLocation,
          maxymiserEnabled,
        } = data.application.configurations;

        return (
          <React.Fragment>
            {maxymiserEnabled && maxymiserScriptLocation ? (
              <Head>
                <script src={maxymiserScriptLocation} />
              </Head>
            ) : null}

            {children}
          </React.Fragment>
        );
      }}
    </SSRAwareQuery>
  );
};

MaxymiserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MaxymiserProvider;
